import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import CardLink, { cardLinkImageStyles } from '~components/Card/CardLink';

const KidsForCureCard: React.FC = () => (
  <CardLink to="/supporting-each-other/kids-for-a-cure" variant="blue" title="Les enfants pour une guérison">
    <StaticImage src="../../images/kids-for-a-cure.jpg" alt="" style={cardLinkImageStyles} />
  </CardLink>
);

export default KidsForCureCard;
